import { Paper } from '@mui/material';
import styled from 'styled-components';

const BaseConversationCard = styled(Paper)`
  display: flex;
  flex-direction: column;
  border: 2px solid ${({ theme }) => theme.palette.common.white};
  width: 400px;
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows[1]};
`;

export const AnimatedBaseConversationCard = styled(BaseConversationCard)`
  @media (prefers-reduced-motion: no-preference) {
    animation: slide-in-animation 300ms forwards ease-out;
  }

  @keyframes slide-in-animation {
    0% {
      transform: translateY(50%);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;
